import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import MainContent from "./MainContent/MainContent";
import Navbar from "./Navbar/Navbar";
import Sidebar from "./Sidebar/Sidebar";

import "./ClientLayoutPages.scss";

export default function ClientLayoutPages() {
  const location = useLocation();
  const previousPathRef = useRef(location.pathname);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    if (previousPathRef.current !== location.pathname) {
      setIsSidebarOpen(false);
      previousPathRef.current = location.pathname;
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <MainContent>
      <section className="client-layout-shell flex min-h-screen portal-shell">
        <Sidebar isOpen={isSidebarOpen} toggle={setIsSidebarOpen} />
        <div className="client-layout-main layout flex min-h-screen w-full flex-col lg:mr-72">
          <Navbar isOpen={isSidebarOpen} toggle={setIsSidebarOpen} />
          <div className="client-layout-content relative z-10 flex flex-1 flex-col gap-3 px-2 pb-3 pt-2 md:px-3">
            <div className="client-layout-outlet portal-panel-soft flex-1 overflow-x-hidden rounded-[2rem]">
              <Outlet />
            </div>
            {/* <Footer /> */}
          </div>
        </div>
        {/* <ThemeToggle /> */}
      </section>
    </MainContent>
  );
}
